import { Button } from 'antd';
import { useIntl } from 'react-intl';
import { ErrorNotificationSvg } from '../../assets/SVGs/SVGs';

type Props = { setShowPricingPlan: any; handleCancelModal: any };

const ModalMessageCantAddLocation = ({
  setShowPricingPlan,
  handleCancelModal,
}: Props) => {
  const intl = useIntl();

  return (
    <div className="flex flex-col items-center justify-center w-full gap-6">
      <span>{ErrorNotificationSvg}</span>
      <h3 className="text-xl text-[#020418] text-center">
        {intl.formatMessage({ id: 'modalTitle' })}
      </h3>
      <p className="text-sm text-[#75757E] max-w-[300px] text-center">
        {intl.formatMessage({ id: 'modalDescription' })}
      </p>
      <Button
        onClick={() => {
          handleCancelModal();
          setShowPricingPlan(true);
        }}
        type="primary"
        className="min-w-[150px] w-fit mt-6 px-12 py-3"
      >
        {intl.formatMessage({ id: 'updatePlan' })}
      </Button>
    </div>
  );
};

export default ModalMessageCantAddLocation;
